export const environment = {
  env: 'PROD',
  production: true,
  // serverBaseUrl: 'https://agent-api.herokuapp.com',
  //serverUrl: 'https://agent-api.herokuapp.com/v1'
  // serverBaseUrl: 'https://uat-pip-api.nissansecurityplus-products.com',
  // serverUrl: 'https://uat-pip-api.nissansecurityplus-products.com/v1',
  // s3Url: 'https://dowc-pipqa.s3.amazonaws.com',
  siteKey: '6LcHBxAcAAAAAM5lFam36od_3C_HN4jsL8gxaejL',
  // devServiceURL: 'https://devservices.dowc.com'
  serverBaseUrl: 'https://pip-api.nissansecurityplus-products.com',
  serverUrl: 'https://pip-api.nissansecurityplus-products.com/v1',
  s3Url: 'https://dowc-pip.s3.amazonaws.com',
  // siteKey: '6LdoHzMcAAAAANhCct28ycJyWCI7f6INwlZIZdqr',
  devServiceURL: 'https://devservices.dowc.com',
  logoURL:'https://dowc-assets.s3.us-east-1.amazonaws.com/Nissan-loog+1.png',
  favIcon:'https://dowc-assets.s3.us-east-1.amazonaws.com/Nissan-Fav+1.png',
  primaryColor:'#000',
  secondaryColor:'#4c4a4a',
};
